import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { TradeStoreService } from 'projects/app-default/src/app/multisite/trade/trade-store.service';
import { EListingLabelOptionId, LocalProduct } from '../../../model/product/product.decorator';
@Component({
    selector: 'product-view-title',
    templateUrl: './product-view-title.html',
    standalone: true,
    imports: [NgStyle, TranslationModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductViewTitleComponent extends UiComponent {
    private tradestoreService = inject(TradeStoreService);

    @Input({
        required: true
    })
    product!: LocalProduct<IProductDataV3>;
    @Input()
    parent?: LocalProduct<IProductDataV3>;

    protected acyncCd = false;

    protected get isTrade(): boolean {
        return this.tradestoreService.isTradeStore();
    }

    protected get showLabel(): boolean {
        if (this.isTrade) {
            if ((this.product as LocalProduct).getListingLabel() === EListingLabelOptionId.sale) {
                return (this.product as LocalProduct).tradeSalePrice ? true : false;
            }
        }
        return !!this.product.label;
    }
}
